// extracted by mini-css-extract-plugin
export default {"patternDatesMeta":"CalendarWidget_patternDatesMeta__7qtwi","dateTypePicker":"CalendarWidget_dateTypePicker__NvF6z"};